const imagesCarousel = {
  backgroundColor: ({ theme }) => theme.colors.goldMetallic,
}

export default imagesCarousel
